import { FunctionComponent, createContext, useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { providerErrorMessage } from '../utils'
import { GenericListCache } from './GenericListCache'

const GenericListCacheContext = createContext<GenericListCache | null>(null)

export const useGenericListCache = (): GenericListCache => {
  const store = useContext(GenericListCacheContext)

  if (!store) {
    throw new Error(providerErrorMessage('GenericListCache'))
  }

  return store
}

export const GenericListCacheProvider: FunctionComponent<{ children?: React.ReactNode }> = observer(({ children }) => {
  const genericlistcache = useMemo(() => new GenericListCache(10), [])

  return (
    <GenericListCacheContext.Provider value={genericlistcache}>
      {children}
    </GenericListCacheContext.Provider>
  )
})